/** Used to match @see KeyboardEvent.code values. */
export enum KeyCode {
  d = 'KeyD'
}
